import '../tw.css';
import { useTranslation } from "react-i18next";
import ImgCenteredCaption from '../Components/ImgCenteredCaption';
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import ListItem from '../Components/ListItem';
import Quotes from '../Components/Quotes';
import { GetBodyFontClass, GetHeaderFontClass } from '../Helper/Helper';

export default function OurBeliefPage(){
    const { t } = useTranslation("ourBelief");
    let doctrines = [t('doctrines.1'),t('doctrines.2'),t('doctrines.3'),t('doctrines.4'),t('doctrines.5'),t('doctrines.6'),t('doctrines.7'),t('doctrines.8'),t('doctrines.9'),t('doctrines.10'),t('doctrines.11')];
    return <div className='mb-10'>
        <ImgCenteredCaption imageSrc={"https://lccccompany.blob.core.windows.net/public/ourBeliefTop.jpg"} alt="Image of a cross">
            <h1 className={`md:text-6xl text-2xl text-center text-white ${GetHeaderFontClass()}`}>{t('title')}</h1>
            <p className={`md:text-2xl text-lg text-center text-white mt-5 ${GetBodyFontClass()}`}>{t('subTitle')}</p>
        </ImgCenteredCaption>
        <div className='mx-10 lg:mx-20'>
            {/* Doctrines */}
            {doctrines && doctrines.map(doc => { 
                return <ListItem icon={<FontAwesomeIcon icon={solid('play')}/>}>
                    <p className={`${GetBodyFontClass()}`}>{doc}</p>
                </ListItem>;
                })
            }
            {/* Disclaimer */}
            <Quotes classNames='sm:mx-10 md:mx-24 lg:mx-48'>
                <div className='flex items-center'>
                    <FontAwesomeIcon className='flex-none mr-5' icon={solid('circle-exclamation')} size="2x"/>
                    <p className={`flex-initial ${GetBodyFontClass()}`}>{t('disclaimer')}</p>
                </div>
            </Quotes>
        </div>
    </div>
}
